import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginScreen from './pages/LoginScreen';
import MainLayout from './components/layout/MainLayout';
import DashboardScreen from './pages/DashboardScreen';
import DutyManagementScreen from './pages/DutyManagementScreen';
import LawajamManagementScreen from './pages/LawajamManagementScreen';
import MemberManagementScreen from './pages/MemberManagementScreen';
import SettingsScreen from './pages/SettingsScreen';
import NotificationsScreen from './pages/NotificationsScreen';
export function App() {
  // Use state to track authentication instead of a hardcoded value
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // Function to handle login
  const handleLogin = () => {
    setIsAuthenticated(true);
  };
  // Function to handle logout
  const handleLogout = () => {
    setIsAuthenticated(false);
  };
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace data-id="element-3" /> : <LoginScreen onLogin={handleLogin} data-id="element-4" />} data-id="element-2" />
        <Route path="/" element={isAuthenticated ? <MainLayout onLogout={handleLogout} data-id="element-6" /> : <Navigate to="/login" replace data-id="element-7" />} data-id="element-5">
          <Route index element={<DashboardScreen data-id="element-9" />} data-id="element-8" />
          <Route path="duties" element={<DutyManagementScreen data-id="element-11" />} data-id="element-10" />
          <Route path="lawajam" element={<LawajamManagementScreen data-id="element-13" />} data-id="element-12" />
          <Route path="members" element={<MemberManagementScreen data-id="element-15" />} data-id="element-14" />
          <Route path="settings" element={<SettingsScreen data-id="element-17" />} data-id="element-16" />
          <Route path="notifications" element={<NotificationsScreen data-id="element-19" />} data-id="element-18" />
        </Route>
      </Routes>
    </Router>;
}